import { Component, OnInit, Inject } from '@angular/core';
import { userListDB } from 'src/app/shared/tables/list-users';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})
export class ListUserComponent implements OnInit {
  public user_list = []
  message = null;
  class = null;

  constructor(private router: Router, private api: ApiService, private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) {
    // this.user_list = userListDB.list_user;
  }

  public settings = {
    actions: {
      position: 'right',
      add: false
    },
    edit: {
      confirmSave: true
    },
    delete :{
      confirmDelete: true
    },
    columns: {
      firstName: {
        title: 'First Name',
      },
      lastName: {
        title: 'Last Name',
      },
      email: {
        title: 'Email'
      },
      role: {
        title: 'Department'
      },
    },
  };

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/memberreg').subscribe(
        data => {
          this.user_list = data.data;
          // console.log(this.studymodes);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  delete(id) {
    // console.log(this.Form.value)
    if(confirm("Are you sure to deactivate account? ")){
    var data1 = {
      "active" : '0',
      "_id" : id,
    };
    this.http.put<any>(this.api_endpoint+'/memberreg/', data1).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Deactivated Profile';
          this.class = 'btn btn-success';
          window.scrollTo(document.documentElement.clientWidth, 0);
          this.ngOnInit();
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }
  }

  activate(id, activestatus) {
    // console.log(this.Form.value)
    if(confirm("Are you sure to deactivate account? ")){
    var data1 = {
      "active" : '1',
      "_id" : id,
    };
    this.http.put<any>(this.api_endpoint+'/memberreg/', data1).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Activated Profile';
          this.class = 'btn btn-success';
          window.scrollTo(document.documentElement.clientWidth, 0);
          this.ngOnInit();
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }
  }

}

